import { MaterialSymbol } from "@ui/MaterialSymbol";
import { ClipCount } from "@ui/molecules/ClipCount/ClipCount";
import { PrivatePublicIcon } from "@ui/molecules/PrivatePublicIcon/PrivatePublicIcon";
import { HStack } from "@ui/Stack";
import { UpdatedAt } from "@ui/UpdatedAt";
import { For, Show } from "solid-js";
import type { ListBoardItemResponse } from "@/client";

export const MoveBoardItem = ({
	board,
	onClick,
	isSelected,
	isFocused,
	onFocus,
	ref,
}: {
	board: ListBoardItemResponse;
	onClick: () => void;
	isSelected: () => boolean;
	isFocused: () => boolean;
	onFocus?: () => void;
	index: number;
	ref?: (el: HTMLButtonElement) => void;
}) => {
	return (
		<button
			ref={ref}
			type="button"
			role="option"
			aria-selected={isSelected()}
			tabIndex={isFocused() ? 0 : -1}
			onClick={onClick}
			onFocus={onFocus}
			class={`board-item ${isSelected() ? "selected" : ""} ${isFocused() ? "focused" : ""}`}
		>
			<HStack justify="space-between" align="center" spacing="small">
				<div>{board.title}</div>
				<CheckIcon isSelected={isSelected()} privacy={board.privacy} />
			</HStack>
			<HStack justify="space-between">
				<UpdatedAt updatedAt={board.updated_at} />
				<ClipCount clipCount={board.clip_count ?? 0} />
			</HStack>
			<HStack spacing="small" justify="start" class="thumbnail-list">
				<For each={board.thumbnail_images}>
					{(thumbnail) => (
						<img src={thumbnail.url} class="thumbnail" alt="thumbnail" />
					)}
				</For>
			</HStack>
		</button>
	);
};

const CheckIcon = (props: { isSelected: boolean; privacy: string }) => {
	return (
		<Show
			when={props.isSelected}
			fallback={<PrivatePublicIcon privacy={props.privacy} />}
		>
			<div class="check-icon-container">
				<MaterialSymbol class="check-icon-active" symbol="check" />
			</div>
		</Show>
	);
};
